<template>
  <div>
    <div>
      <b-navbar toggleable="lg" type="dark" variant="primary">
        <b-navbar-brand :to="{ name: 'home' }">Dashtaco</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right>
              <template #button-content>
                  <i class="fa fa-bell" aria-hidden="true"></i>
                  <sup style="top: 0em; left: -0.1rem; font-size: 3rem;">
                    <span v-if="hasNotification" class="text-danger">&#8226;</span>
                    <span v-else class="text-primary">&#8226;</span>
                  </sup>     
              </template>

              <div v-if="notifications.length > 0" style="max-height: 20rem; overflow-y: scroll;">
                <div v-for="(notif, key) in notifications" :key="key">
                  <notification :notification="notif" :pdv="fullUser.salespoint"/>
                </div>                
              </div>
              <div v-else class="container">
                <div class="my-auto text-center pt-3" style="width: 20rem;">
                  <p><i>Vous n'avez pas de notification</i> </p>
                </div>
              </div>
              
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right>
              <template #button-content>
                <span class="text-uppercase">
                  {{ user.username }} 
                  <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                </span> 
              </template>
              <b-dropdown-item id="btn-profil" :to="{ name: 'user'}">Profil</b-dropdown-item>
              <b-dropdown-item id="btn-logout" @click="logout">Déconnexion</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>  
  </div>
</template>

<script>
import init from "@/core/mixins/init";
import {mapActions, mapGetters, mapState} from "vuex";
import moment from 'moment';
import Pusher from "pusher-js";
import Notification from "@/modules/notifications/views/Notification";

moment.locale('fr');

export default {
  name: "Navbar",
  components: {
    Notification
  },
  mixins: [init],
  computed:{
    ...mapState('notifications',['notifications','hasNotification']),
    ...mapState('auth',['user','fullUser']),
    ...mapGetters('auth',['isAuthenticated']),
    panel: {
      get(){
        return this.isPanelShow
      },
      set(newName){
        return newName
      }
    }
  },
  created() {
    this.isAlwaysLogIn()
    this.setFullUser()
    if(this.fullUser.roles.includes('ROLE_ADMIN')) this.loadNotifications()
    else this.loadNotifications(this.fullUser.salespoint)
    
    if(this.fullUser.isFirstConnexion && this.$route.name !== 'first-connexion'){
     this.$router.push({name: 'first-connexion'})
    }
  },
  data(){
    return{
      count: 0,
      show: false,
      dropdownProfile: false,
      dropdownNotification: false,
      executed:0
    }
  },
  methods:{
    ...mapActions('auth',['isAlwaysLogIn','logout','setFullUser']),
    ...mapActions('notifications',['loadNotifications','diplayNotification','markHasRead'])
  },
  mounted() {
    // **** Channel **** //
    //Pusher.logToConsole = true;
    const eventChannel = 'notification'
    const pusher = new Pusher('1541dac6988789844272', { cluster: 'eu' });

    let here = this
    pusher.subscribe(this.fullUser.salespoint).bind(eventChannel, function(data) {
      here.diplayNotification(data)
      const audio = new Audio('/assets/notification/mixkit-positive-notification-951.wav');
      audio.play();
    });

  },
}
</script>

<style>
hr.divider {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.dropdown-toggle::after {
  content: none !important;
}
.dropdown-item {
    white-space: pre-wrap;
}
.navbar {
  z-index: 1000; 
}
a:hover{
  text-decoration: none;
}
.child1 {
  position: absolute;
  opacity: 0.8;
  left: 17.5rem;
  margin-top: -2rem;
}
.b-sidebar{
  width: 23rem !important;
}
.b-sidebar > .b-sidebar-body {
  width: auto !important;
}
</style>
